import { createZodDto } from 'nestjs-zod/dto';
import z from 'zod';
import { removeNullAndUndefinedValues } from '#conversion.utils';
import { classicFilespaceIdValidator, dateParser, encryptedKeyByRsaKeyValidator, enumParser, filespaceFormatValidator, FilespaceMigrationStatus, filespaceNameValidator, } from '#validation';
import { initCryptoParamsSchema } from '../filespace/filespace-create.dto';
const layoutFilespaceMigrationSourceSchema = z.object({
    filespaceId: z.uuid(),
});
const classicFilespaceMigrationSourceSchema = z.object({
    classicFilespaceId: classicFilespaceIdValidator,
    classicFilespaceFsId: z.uuid().optional(),
});
const filespaceMigrationSourceSchema = layoutFilespaceMigrationSourceSchema.or(classicFilespaceMigrationSourceSchema);
const filespaceMigrationDestinationSchema = z.object({
    workspaceId: z.string(),
    filespace: z
        .object({
        id: z.string(),
        name: z.string(),
        version: z.number(),
        hubDataEndpoints: z.array(z.string()),
        qualifiedName: z.string(),
    })
        .optional()
        .nullish(),
});
export const FilespaceMigrationSchema = z
    .object({
    id: z.string(),
    createdAt: dateParser(),
    updatedAt: dateParser().optional(),
    createdByUserId: z.string(),
    status: enumParser(FilespaceMigrationStatus),
    canCancel: z.boolean(),
    error: z.string().optional().nullish(),
    source: filespaceMigrationSourceSchema,
    destination: filespaceMigrationDestinationSchema.transform(removeNullAndUndefinedValues),
})
    .transform(removeNullAndUndefinedValues);
export class FilespaceMigrationDto extends createZodDto(FilespaceMigrationSchema) {
}
export const filespaceMigrationsResponseSchema = z.object({
    migrations: z.array(FilespaceMigrationSchema),
});
export class FilespaceMigrationsResponseDto extends createZodDto(filespaceMigrationsResponseSchema) {
}
const createLayoutFilespaceMigrationSourceSchema = z.object({
    filespaceId: z.uuid(),
});
const createClassicFilespaceMigrationSourceSchema = z.object({
    classicFilespaceId: classicFilespaceIdValidator,
});
const createFilespaceMigrationSourceSchema = createLayoutFilespaceMigrationSourceSchema.or(createClassicFilespaceMigrationSourceSchema);
const createFilespaceMigrationDestinationSchema = z
    .object({
    filespaceName: filespaceNameValidator,
    filespaceFormat: filespaceFormatValidator,
})
    .and(z.object({
    eFilespaceRootPrivateKeyByAdminKey: encryptedKeyByRsaKeyValidator,
    initCryptoParams: initCryptoParamsSchema,
}));
const createFilespaceMigrationSchema = z.object({
    source: createFilespaceMigrationSourceSchema,
    destination: createFilespaceMigrationDestinationSchema,
});
export class CreateFilespaceMigrationDto extends createZodDto(createFilespaceMigrationSchema) {
}
const filespaceStatsResponseSchema = z.object({
    stats: z
        .object({
        usedStorage: z.number().optional(),
    })
        .transform(removeNullAndUndefinedValues),
    status: enumParser(FilespaceMigrationStatus),
});
export class FilespaceStatsResponseDto extends createZodDto(filespaceStatsResponseSchema) {
}
const migrationFilespaceSchema = z.object({
    id: z.string(),
    name: z.string(),
    qualifiedName: z.string(),
    version: z.number(),
    format: filespaceFormatValidator,
    hub: z.object({
        ip: z.string(),
        region: z.string(),
        backupRegion: z.string().optional(),
        provider: z.string(),
    }),
});
export class MigrationFilespaceDto extends createZodDto(migrationFilespaceSchema) {
}
const migrationWorkspaceNameAvailabilityQuerySchema = z.object({
    name: z.string(),
});
export class MigrationWorkspaceNameAvailabilityQueryDto extends createZodDto(migrationWorkspaceNameAvailabilityQuerySchema) {
}
const migrationWorkspaceNameAvailabilityResponseSchema = z.object({
    isAvailable: z.boolean(),
});
export class MigrationWorkspaceNameAvailabilityResponseDto extends createZodDto(migrationWorkspaceNameAvailabilityResponseSchema) {
}
